import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import VueLocalStorage from 'vue-localstorage';
import { AsyncDataPlugin } from 'vue-async-data-2';
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-vue/dist/bootstrap-vue.css');

Vue.use(AsyncDataPlugin);
Vue.use(BootstrapVue);
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true
});
Vue.use(VueFire)
firebase.initializeApp({
  apiKey: "AIzaSyDMd3L-hRw6g_77JTP_us7ypOUzc3G93P8",
  projectId: "britehouse-team-rating-app",
  databaseURL: "https://britehouse-team-rating-app.firebaseio.com",
})

export const db = firebase.firestore();

new Vue({
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js